import React from 'react';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import './Modal-Beneficiarios-Cile.scss';


class ModalBeneficiariosCile extends React.Component {
    constructor(props) {
        super(props);

        this.verificarStatus = this.verificarStatus.bind(this);


        this.Configurations = new Configurations();

    }

    verificarStatus(item) {

        let textoBadge;
        let corBadge;
        let textoMensagem = "Ativo desde";
        if (item.solicitante) {
            textoBadge = "Solicitante";
            corBadge = "success";

        } else if (item.pendencia) {
            textoBadge = "Pendente";
            corBadge = "warning";
            textoMensagem = "Convite enviado em";

        } else {
            textoBadge = "Confirmado";
            corBadge = "info";
        }

        return {
            textoBadge, corBadge, textoMensagem
        }

    }

    render() {
        const {
            isOpen,
            toggle,
            listaBeneficiariosCile,
            infos,
        } = this.props;

        return (
            <Modal className="modal-beneficiarios-cile" size="lg" isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>Beneficiários CILE</ModalHeader>
                <ModalBody>

                    <div className="col-12">
                        <div className='row'>
                            <div className='col-12 text-left'>
                                <span><strong>{infos.nomePlano}</strong></span>
                            </div>
                        </div>
                        <div className='row py-2'>
                            <div className='col-6'>
                                <p>Vigência do plano: <strong>{moment(infos.dtInicio).format("DD/MM/YYYY")} - {moment(infos.dtFim).format("DD/MM/YYYY")} </strong></p>
                            </div>
                            <div className='col-6'>
                                <p>Usuários do plano: <strong>{infos.acessos - infos.vagas}/{infos.acessos}</strong></p>
                            </div>
                        </div>
                        <table className="tabela-beneficiarios-cile table w-100 text-center table-bordered">
                            <thead>
                                <tr>
                                    <th width="35%">Nome</th>
                                    <th width="25%">Status</th>
                                    <th width="25%">Contato</th>
                                    <th width="15%">Obs:</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaBeneficiariosCile.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td width="35%" className='text-center'>{item.nome}</td>
                                            <td width="25%" className='text-center'><span className={`badge badge-${this.verificarStatus(item).corBadge}`}>{this.verificarStatus(item).textoBadge}</span></td>
                                            <td width="25%" className='text-center'>{item.contato}</td>
                                            <td width="15%" className='text-center'>{this.verificarStatus(item).textoMensagem} {moment(item.dtInicioBenef).format("DD/MM/YYYY")}</td>
                                        </tr>
                                    )
                                })
                                }
                            </tbody>
                        </table>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

}


export default ModalBeneficiariosCile;


